import { ObjectDefinitions } from "../types/ObjectDefinitionTypes";

const objects: ObjectDefinitions[] = [
  {
    name: "plant_plugs",
    image: "plant_plugs_empty",
    type: "controllableObject",
    states: [
      {
        name: "empty",
        image: "plant_plugs_empty",
        label: {
          topLine: {
            text: "Plant plugs",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "0/20 seeds",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          offset: -80,
        },
      },
      {
        name: "filled",
        image: "plant_plugs_filled",
        label: {
          topLine: {
            text: "Plant plugs",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "20/20 seeds",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          offset: -80,
        },
      },
      {
        name: "hidden",
        image: "hidden",
      },
    ],
  },
  {
    name: "drying_oven",
    image: "drying_oven_closed",
    type: "interactableObject",
    defaultState: "closed",
    states: [
      {
        name: "closed",
        image: "drying_oven_closed",
        label: {
          text: "Drying oven",
          offset: -90,
        },
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [{ nextState: "open" }],
            type: "UpdateState",
          },
          {
            icon: "microplate_reader_power_button",
            title: "Power",
            type: "UpdateState",
            actionName: "TOGGLE_DRYING_OVEN",
            stateUpdates: [],
          },
          {
            icon: "ConfigApparatusIcon",
            title: "Temperature settings",
            type: "Modal",
            modal: "DryingOvenModal",
          },
        ],
      },
      {
        name: "open",
        image: "drying_oven_open",
        label: {
          text: "Drying oven",
          offset: -90,
        },
        buttons: [
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [{ nextState: "closed" }],
            type: "UpdateState",
          },
          {
            icon: "ConfigApparatusIcon",
            title: "Temperature settings",
            type: "Modal",
            modal: "DryingOvenModal",
          },
        ],
      },
      {
        name: "closed__weigh_boat",
        image: "drying_oven_closed__weigh_boat",
        label: {
          text: "Drying oven",
          offset: -90,
        },
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [{ nextState: "open__weigh_boat" }],
            type: "UpdateState",
          },
          {
            icon: "microplate_reader_power_button",
            title: "Power",
            type: "UpdateState",
            actionName: "TOGGLE_DRYING_OVEN",
            stateUpdates: [],
          },
          {
            icon: "ConfigApparatusIcon",
            title: "Temperature settings",
            type: "Modal",
            modal: "DryingOvenModal",
          },
        ],
      },
      {
        name: "open__weigh_boat",
        image: "drying_oven_open__weigh_boat",
        label: {
          text: "Drying oven",
          offset: -90,
        },
        buttons: [
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [{ nextState: "closed__weigh_boat" }],
            type: "UpdateState",
          },
          {
            icon: "scale_eject_weigh_boat",
            title: "Eject weigh boat",
            type: "UpdateState",
            stateUpdates: [{ nextState: "open" }],
            actionName: "EJECT_FROM_OVEN",
          },
          {
            icon: "ConfigApparatusIcon",
            title: "Temperature settings",
            type: "Modal",
            modal: "DryingOvenModal",
          },
        ],
      },
      {
        name: "closed__weigh_boat__plant_day_7_oven_dried",
        image: "drying_oven_closed__weigh_boat__plant_day_7_oven_dried",
        label: {
          text: "Drying oven",
          offset: -90,
        },
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [
              { nextState: "open__weigh_boat__plant_day_7_oven_dried" },
            ],
            type: "UpdateState",
          },
          {
            icon: "microplate_reader_power_button",
            title: "Power",
            type: "UpdateState",
            actionName: "TOGGLE_DRYING_OVEN",
            stateUpdates: [],
          },
          {
            icon: "ConfigApparatusIcon",
            title: "Temperature settings",
            type: "Modal",
            modal: "DryingOvenModal",
          },
        ],
      },
      {
        name: "open__weigh_boat__plant_day_7_oven_dried",
        image: "drying_oven_open__weigh_boat__plant_day_7_oven_dried",
        label: {
          text: "Drying oven",
          offset: -90,
        },
        buttons: [
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [
              { nextState: "closed__weigh_boat__plant_day_7_oven_dried" },
            ],
            type: "UpdateState",
          },
          {
            icon: "scale_eject_weigh_boat",
            title: "Eject weigh boat",
            type: "UpdateState",
            stateUpdates: [{ nextState: "open" }],
            actionName: "EJECT_FROM_OVEN",
          },
          {
            icon: "ConfigApparatusIcon",
            title: "Temperature settings",
            type: "Modal",
            modal: "DryingOvenModal",
          },
        ],
      },
      {
        name: "closed__weigh_boat__plant_day_14_oven_dried",
        image: "drying_oven_closed__weigh_boat__plant_day_14_oven_dried",
        label: {
          text: "Drying oven",
          offset: -90,
        },
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [
              { nextState: "open__weigh_boat__plant_day_14_oven_dried" },
            ],
            type: "UpdateState",
          },
          {
            icon: "microplate_reader_power_button",
            title: "Power",
            type: "UpdateState",
            actionName: "TOGGLE_DRYING_OVEN",
            stateUpdates: [],
          },
          {
            icon: "ConfigApparatusIcon",
            title: "Temperature settings",
            type: "Modal",
            modal: "DryingOvenModal",
          },
        ],
      },
      {
        name: "open__weigh_boat__plant_day_14_oven_dried",
        image: "drying_oven_open__weigh_boat__plant_day_14_oven_dried",
        label: {
          text: "Drying oven",
          offset: -90,
        },
        buttons: [
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [
              { nextState: "closed__weigh_boat__plant_day_14_oven_dried" },
            ],
            type: "UpdateState",
          },
          {
            icon: "scale_eject_weigh_boat",
            title: "Eject weigh boat",
            type: "UpdateState",
            stateUpdates: [{ nextState: "open" }],
            actionName: "EJECT_FROM_OVEN",
          },
          {
            icon: "ConfigApparatusIcon",
            title: "Temperature settings",
            type: "Modal",
            modal: "DryingOvenModal",
          },
        ],
      },
      {
        name: "closed__weigh_boat__plant_day_7",
        image: "drying_oven_closed__weigh_boat__plant_day_7",
        label: {
          text: "Drying oven",
          offset: -90,
        },
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [{ nextState: "open__weigh_boat__plant_day_7" }],
            type: "UpdateState",
          },
          {
            icon: "microplate_reader_power_button",
            title: "Power",
            type: "UpdateState",
            actionName: "TOGGLE_DRYING_OVEN",
            stateUpdates: [],
          },
          {
            icon: "ConfigApparatusIcon",
            title: "Temperature settings",
            type: "Modal",
            modal: "DryingOvenModal",
          },
        ],
      },
      {
        name: "open__weigh_boat__plant_day_7",
        image: "drying_oven_open__weigh_boat__plant_day_7",
        label: {
          text: "Drying oven",
          offset: -90,
        },
        buttons: [
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [{ nextState: "closed__weigh_boat__plant_day_7" }],
            type: "UpdateState",
          },
          {
            icon: "scale_eject_weigh_boat",
            title: "Eject weigh boat",
            type: "UpdateState",
            stateUpdates: [{ nextState: "open" }],
            actionName: "EJECT_FROM_OVEN",
          },
          {
            icon: "ConfigApparatusIcon",
            title: "Temperature settings",
            type: "Modal",
            modal: "DryingOvenModal",
          },
        ],
      },
      {
        name: "closed__weigh_boat__plant_day_14",
        image: "drying_oven_closed__weigh_boat__plant_day_14",
        label: {
          text: "Drying oven",
          offset: -90,
        },
        buttons: [
          {
            icon: "door_open_icon",
            title: "Open door",
            stateUpdates: [{ nextState: "open__weigh_boat__plant_day_14" }],
            type: "UpdateState",
          },
          {
            icon: "microplate_reader_power_button",
            title: "Power",
            type: "UpdateState",
            actionName: "TOGGLE_DRYING_OVEN",
            stateUpdates: [],
          },
          {
            icon: "ConfigApparatusIcon",
            title: "Temperature settings",
            type: "Modal",
            modal: "DryingOvenModal",
          },
        ],
      },
      {
        name: "open__weigh_boat__plant_day_14",
        image: "drying_oven_open__weigh_boat__plant_day_14",
        label: {
          text: "Drying oven",
          offset: -90,
        },
        buttons: [
          {
            icon: "door_close_icon",
            title: "Close door",
            stateUpdates: [{ nextState: "closed__weigh_boat__plant_day_14" }],
            type: "UpdateState",
          },
          {
            icon: "scale_eject_weigh_boat",
            title: "Eject weigh boat",
            type: "UpdateState",
            stateUpdates: [{ nextState: "open" }],
            actionName: "EJECT_FROM_OVEN",
          },
          {
            icon: "ConfigApparatusIcon",
            title: "Temperature settings",
            type: "Modal",
            modal: "DryingOvenModal",
          },
        ],
      },
    ],
  },
  {
    name: "weigh_boats",
    image: "weigh_boats",
    type: "interactableObject",
  },
  {
    name: "weigh_boat",
    image: "default",
    type: "controllableObject",
    states: [
      {
        name: "hidden",
        image: "hidden",
      },
      {
        name: "hidden_on_drop",
        image: "hidden",
      },
      {
        name: "hidden_on_drop_oven_dried",
        image: "hidden",
      },
      {
        name: "hidden_on_drop_oven_dried_day_14",
        image: "hidden",
      },
      {
        name: "default",
        image: "weigh_boat",
      },
      {
        name: "plant_day_7",
        image: "weigh_boat__fresh_plant_day_7",
      },
      {
        name: "plant_day_14",
        image: "weigh_boat__fresh_plant_day_14",
      },
      {
        name: "plant_day_7_wet",
        image: "weigh_boat__fresh_plant_wet_day_7",
      },
      {
        name: "plant_day_14_wet",
        image: "weigh_boat__fresh_plant_wet_day_14",
      },
      {
        name: "plant_day_7_oven_dried",
        image: "weigh_boat__dried_plant_day_7",
      },
      {
        name: "plant_day_14_oven_dried",
        image: "weigh_boat__dried_plant_day_14",
      },
    ],
  },
  {
    name: "grow_light",
    image: "grow_light_off",
    type: "interactableObject",
    defaultState: "off",
    states: [
      {
        name: "off",
        image: "grow_light_off",
        label: {
          text: "Grow light",
        },
        buttons: [
          {
            icon: "LightOnButtonIcon",
            title: "Turn on UV Light",
            stateUpdates: [{ nextState: "on" }],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "on",
        image: "grow_light_on",
        label: {
          text: "Grow light",
        },
        buttons: [
          {
            icon: "LightOffButtonIcon",
            title: "Turn off UV light",
            stateUpdates: [{ nextState: "off" }],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "off__seeds",
        image: "grow_light_off__seeds",
        label: {
          topLine: {
            text: "Grow light",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "20 planted seeds",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
        },
        buttons: [
          {
            icon: "LightOnButtonIcon",
            title: "Turn on UV light",
            stateUpdates: [{ nextState: "on__seeds" }],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "on__seeds",
        image: "grow_light_on__seeds",
        label: {
          topLine: {
            text: "Grow light",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "20 planted seeds",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
        },
        buttons: [
          {
            icon: "LightOffButtonIcon",
            title: "Turn off UV light",
            stateUpdates: [{ nextState: "off__seeds" }],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "off__plant_day_7",
        image: "grow_light_off__plant_day_7",
        label: {
          topLine: {
            text: "Grow light",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "7-day-old plants",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
        },
        buttons: [
          {
            icon: "LightOnButtonIcon",
            title: "Turn on UV light",
            stateUpdates: [{ nextState: "on__plant_day_7" }],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "on__plant_day_7",
        image: "grow_light_on__plant_day_7",
        label: {
          topLine: {
            text: "Grow light",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "7-day-old plants",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
        },
        buttons: [
          {
            icon: "LightOffButtonIcon",
            title: "Turn off UV light",
            stateUpdates: [{ nextState: "off__plant_day_7" }],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "off__plant_day_14",
        image: "grow_light_off__plant_day_14",
        label: {
          topLine: {
            text: "Grow light",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "14-day-old plants",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
        },
        buttons: [
          {
            icon: "LightOnButtonIcon",
            title: "Turn on UV light",
            stateUpdates: [{ nextState: "on__plant_day_14" }],
            type: "UpdateState",
          },
        ],
      },
      {
        name: "on__plant_day_14",
        image: "grow_light_on__plant_day_14",
        label: {
          topLine: {
            text: "Grow light",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "14-day-old plants",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
        },
        buttons: [
          {
            icon: "LightOffButtonIcon",
            title: "Turn off UV light",
            stateUpdates: [{ nextState: "off__plant_day_14" }],
            type: "UpdateState",
          },
        ],
      },
    ],
  },
  {
    name: "seeds",
    image: "seed_bag_filled",
    type: "controllableObject",
    defaultState: "full",
    states: [
      {
        name: "full",
        image: "seed_bag_filled",
        label: {
          topLine: {
            text: "Seeds",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "40/40",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
        },
      },
      {
        name: "half",
        image: "seed_bag_empty",
        label: {
          topLine: {
            text: "Seeds",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "20/40",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
        },
      },
      {
        name: "empty",
        image: "seed_bag_empty",
        label: {
          topLine: {
            text: "Seeds",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "0/40",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
        },
      },
    ],
  },
  {
    name: "harvested_plants",
    image: "plant_7_days_old_wet",
    type: "controllableObject",
    defaultState: "hidden",
    states: [
      {
        name: "hidden",
        image: "hidden",
      },
      {
        name: "hidden_on_drop",
        image: "hidden",
      },
      {
        name: "day_7_wet",
        image: "plant_7_days_old_wet",
        label: {
          topLine: {
            text: "7-day-old plants",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "20 (wet roots)",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
        },
      },
      {
        name: "day_7_dry",
        image: "plant_7_days_old_dry",
        label: {
          topLine: {
            text: "7-day-old plants",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "20",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
        },
      },
      {
        name: "day_14_wet",
        image: "plant_14_days_old_wet",
        label: {
          topLine: {
            text: "14-day-old plants",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "20 (wet roots)",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
        },
      },
      {
        name: "day_14_dry",
        image: "plant_14_days_old_dry",
        label: {
          topLine: {
            text: "14-day-old plants",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "20",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
        },
      },
    ],
  },
  {
    name: "energy_dynamics_scale",
    image: "energy_dynamics_scale_empty",
    type: "compositeInteractableObject",
    defaultState: "empty",
    objects: [
      {
        id: "zero_button",
        name: "Zero Button",
        position: { x: "102", y: "246", z: "5" },
        buttons: ["Zero"],
      },
    ],
    text: [
      {
        name: "DisplayValue",
        text: "0.00 g",
        style:
          "color: white; font-size: 15px; font-family: Bio Sans; font-weight: 700; white-space: nowrap; display: flex; justify-content: center; align-items: center;",
        position: {
          x: "50",
          y: "173",
          z: "10",
        },
      },
    ],
    states: [
      {
        name: "empty",
        image: "energy_dynamics_scale_empty",
        label: {
          text: "Scale",
          offset: -85,
        },
        buttons: [
          {
            icon: "zero",
            title: "Zero",
            type: "UpdateState",
            actionName: "ZERO_SCALE",
            stateUpdates: [],
          },
          {
            icon: "ConfigApparatusIcon",
            title: "Scale settings",
            type: "Modal",
            modal: "ElectronicScaleModal",
          },
        ],
        objects: [
          {
            zero_button: "scale_zero_button",
          },
        ],
      },
      {
        name: "weigh_boat_empty",
        image: "scale__weigh_boat_empty",
        label: {
          topLine: {
            text: "Scale",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "Weigh boat",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          offset: -85,
        },
        buttons: [
          {
            icon: "zero",
            title: "Zero",
            type: "UpdateState",
            actionName: "ZERO_SCALE",
            stateUpdates: [],
          },
          {
            icon: "ConfigApparatusIcon",
            title: "Scale settings",
            type: "Modal",
            modal: "ElectronicScaleModal",
          },
          {
            icon: "scale_eject_weigh_boat",
            title: "Eject weigh boat",
            type: "UpdateState",
            stateUpdates: [{ nextState: "empty" }],
            actionName: "EJECT_FROM_SCALE",
          },
        ],
        objects: [
          {
            zero_button: "scale_zero_button",
          },
        ],
      },
      {
        name: "weigh_boat__plant_day_7_wet",
        image: "scale__weigh_boat__plant_7_days_wet",
        label: {
          topLine: {
            text: "Scale",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "7-day-old plants (wet)",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          offset: -85,
        },
        buttons: [
          {
            icon: "zero",
            title: "Zero",
            type: "UpdateState",
            actionName: "ZERO_SCALE",
            stateUpdates: [],
          },
          {
            icon: "ConfigApparatusIcon",
            title: "Scale settings",
            type: "Modal",
            modal: "ElectronicScaleModal",
          },
          {
            icon: "scale_remove_plant",
            title: "Eject plants",
            type: "UpdateState",
            stateUpdates: [{ nextState: "weigh_boat_empty" }],
            actionName: "EJECT_WET_PLANT_FROM_SCALE",
          },
        ],
        objects: [
          {
            zero_button: "scale_zero_button",
          },
        ],
      },
      {
        name: "weigh_boat__plant_day_7",
        image: "scale__weigh_boat__plant_7_days",
        label: {
          topLine: {
            text: "Scale",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "7-day-old plants",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          offset: -85,
        },
        buttons: [
          {
            icon: "zero",
            title: "Zero",
            type: "UpdateState",
            actionName: "ZERO_SCALE",
            stateUpdates: [],
          },
          {
            icon: "ConfigApparatusIcon",
            title: "Scale settings",
            type: "Modal",
            modal: "ElectronicScaleModal",
          },
          {
            icon: "scale_remove_plant",
            title: "Eject plants",
            type: "UpdateState",
            stateUpdates: [{ nextState: "weigh_boat_empty" }],
            actionName: "EJECT_WET_PLANT_FROM_SCALE",
          },
          {
            icon: "scale_eject_weigh_boat",
            title: "Eject weigh boat",
            type: "UpdateState",
            stateUpdates: [{ nextState: "empty" }],
            actionName: "EJECT_FROM_SCALE",
          },
        ],
        objects: [
          {
            zero_button: "scale_zero_button",
          },
        ],
      },
      {
        name: "weigh_boat__plant_day_7_oven_dried",
        image: "scale__weigh_boat__plant_day_7_oven_dried",
        label: {
          topLine: {
            text: "Scale",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "7-day-old plants (dried)",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          offset: -85,
        },
        buttons: [
          {
            icon: "zero",
            title: "Zero",
            type: "UpdateState",
            actionName: "ZERO_SCALE",
            stateUpdates: [],
          },
          {
            icon: "ConfigApparatusIcon",
            title: "Scale settings",
            type: "Modal",
            modal: "ElectronicScaleModal",
          },
          {
            icon: "scale_eject_weigh_boat",
            title: "Eject weigh boat",
            type: "UpdateState",
            stateUpdates: [{ nextState: "empty" }],
            actionName: "EJECT_FROM_SCALE",
          },
        ],
        objects: [
          {
            zero_button: "scale_zero_button",
          },
        ],
      },
      {
        name: "weigh_boat__plant_day_14_wet",
        image: "scale__weigh_boat__plant_14_days_wet",
        label: {
          topLine: {
            text: "Scale",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "14-day-old plants (wet)",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          offset: -85,
        },
        buttons: [
          {
            icon: "zero",
            title: "Zero",
            type: "UpdateState",
            actionName: "ZERO_SCALE",
            stateUpdates: [],
          },
          {
            icon: "ConfigApparatusIcon",
            title: "Scale settings",
            type: "Modal",
            modal: "ElectronicScaleModal",
          },
          {
            icon: "scale_remove_plant",
            title: "Eject plants",
            type: "UpdateState",
            stateUpdates: [{ nextState: "weigh_boat_empty" }],
            actionName: "EJECT_WET_PLANT_FROM_SCALE",
          },
        ],
        objects: [
          {
            zero_button: "scale_zero_button",
          },
        ],
      },
      {
        name: "weigh_boat__plant_day_14",
        image: "scale__weigh_boat__plant_14_days",
        label: {
          topLine: {
            text: "Scale",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "14-day-old plants",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          offset: -85,
        },
        buttons: [
          {
            icon: "zero",
            title: "Zero",
            type: "UpdateState",
            actionName: "ZERO_SCALE",
            stateUpdates: [],
          },
          {
            icon: "ConfigApparatusIcon",
            title: "Scale settings",
            type: "Modal",
            modal: "ElectronicScaleModal",
          },
          {
            icon: "scale_remove_plant",
            title: "Eject plants",
            type: "UpdateState",
            stateUpdates: [{ nextState: "weigh_boat_empty" }],
            actionName: "EJECT_WET_PLANT_FROM_SCALE",
          },
          {
            icon: "scale_eject_weigh_boat",
            title: "Eject weigh boat",
            type: "UpdateState",
            stateUpdates: [{ nextState: "empty" }],
            actionName: "EJECT_FROM_SCALE",
          },
        ],
        objects: [
          {
            zero_button: "scale_zero_button",
          },
        ],
      },
      {
        name: "weigh_boat__plant_day_14_oven_dried",
        image: "scale__weigh_boat__plant_14_days_oven_dried",
        label: {
          topLine: {
            text: "Scale",
            backgroundColor: "#3E6586",
            textColor: "#FFFFFF",
          },
          bottomLine: {
            text: "14-day-old plants (dried)",
            backgroundColor: "#CCD8E1",
            textColor: "#003E6B",
          },
          offset: -85,
        },
        buttons: [
          {
            icon: "zero",
            title: "Zero",
            type: "UpdateState",
            actionName: "ZERO_SCALE",
            stateUpdates: [],
          },
          {
            icon: "ConfigApparatusIcon",
            title: "Scale settings",
            type: "Modal",
            modal: "ElectronicScaleModal",
          },
          {
            icon: "scale_eject_weigh_boat",
            title: "Eject weigh boat",
            type: "UpdateState",
            stateUpdates: [{ nextState: "empty" }],
            actionName: "EJECT_FROM_SCALE",
          },
        ],
        objects: [
          {
            zero_button: "scale_zero_button",
          },
        ],
      },
    ],
  },
];

export default objects;
